import { ActionTree } from 'vuex';
import { CourseLocationState } from './types';
import { RootState } from '../../types';
import { Logger } from 'fsts';
import moduleUtils from '../moduleUtils';
import { defaultBackendCourseLocation } from '@/shared/backend/courseLocation';
import courseLocation, { CourseLocation } from '@/shared/model/courseLocation';

const logger = new Logger('actions.courseLocations');
export const actions: ActionTree<CourseLocationState, RootState> = {
  getCourseLocations({ commit }, courseId: string) {
    return defaultBackendCourseLocation
      .getCourseLocationsByCourseId(courseId)
      .then((res) => {
        const list = res.data.map(courseLocation.parse);
        commit('setCourseLocations', list);
        return list;
      })
      .catch((e: any) => {
        moduleUtils.error('error', commit, e, logger);
        throw e;
      });
  },
  postMultipleCourseLocations(
    { commit },
    payload: { courseId: string; courseLocations: CourseLocation[] }
  ) {
    return defaultBackendCourseLocation
      .postMultipleCourseLocations(payload.courseId, payload.courseLocations)
      .catch((e: any) => {
        moduleUtils.error('error', commit, e, logger);
        throw e;
      });
  },
};
